import PropTypes from "prop-types";

export const paragraphType = PropTypes.shape({
  title: PropTypes.string,
  headeR: PropTypes.string,
  paragraph: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  btnText: PropTypes.string,
});



// WEBPACK FOOTER //
// ./src/core/admin/components/QA/misc/custom-prop-types.js